// «Настройки аккаунта» — tot ce ţine de contul tău, într-un singur loc.
//
// Până acum stăteau pe profil, sub cifre: schimbarea parolei, bursa, cheile de burse.
// Dar profilul e o pagină pe care o vede şi altcineva, iar setările sunt ale tale — două
// lucruri cu public diferit nu au ce căuta pe aceeaşi pagină. Aşa profilul rămâne ce
// trebuie să fie, o carte de vizită, iar setările primesc loc să se desfăşoare.
//
// Blocurile sunt aceleaşi componente pe care le folosea profilul, mutate, nu copiate.

import { el, clear, bus } from '../core/util.js';
import { icon } from '../ui/icons.js';
import { session } from '../core/session.js';
import { settings } from '../core/state.js';
import { EXCHANGE_LIST } from '../core/exchanges.js';
import { toast, passwordField } from '../ui/components.js';
import { avatarPreset, pictAvatar, pictCover, coperta, NUMAR_PRESETURI, NUMAR_COPERTI } from '../ui/avatars.js';
import { alegeSiEditeaza } from '../ui/image-editor.js';

export class AccountSection {
  constructor(app) {
    this.app = app;
  }

  mount(host) {
    this.root = el('div', { class: 'ac-section' });
    host.append(this.root);
    this.#construieste();
    this.offSession = bus.on('session:change', () => this.#construieste());
  }

  #construieste() {
    clear(this.root);
    const u = session.user;
    if (!u) return;

    this.root.append(el('div', { class: 'ac-doc' }, [
      el('div', { class: 'ideas-head' }, [
        el('h2', { class: 'ideas-title', text: 'Настройки аккаунта' }),
      ]),
      el('p', { class: 'ac-intro', text: 'Всё, что касается вашего входа и рабочего '
        + 'места. Профиль — то, что видят другие; здесь — то, что видите только вы.' }),

      this.#cardProfil(u),
      this.#cardAvatar(u),
      this.#cardCoperta(u),
      this.#cardBursa(),
      this.#cardParola(),
    ]));
  }

  /** Numele, adresa şi descrierea. */
  #cardProfil(u) {
    const bioEl = el('textarea', {
      class: 'ac-textarea', rows: 3, maxlength: 300, value: u.bio || '',
      placeholder: 'Пара слов о себе — что торгуете, на каких таймфреймах',
    });
    const stare = el('span', { class: 'set-hint' });

    return el('section', { class: 'ac-card' }, [
      el('div', { class: 'set-card-head' }, [icon('user', 15), el('h3', { text: 'Профиль' })]),

      el('div', { class: 'ac-rand' }, [
        this.#campCitire('Ник', u.username, 'Ник виден всем и не меняется'),
        this.#campCitire('Почта', u.email || '— не указана',
          u.email_verified ? 'Подтверждена' : 'Не подтверждена'),
      ]),

      el('label', { class: 'ac-camp' }, [
        el('span', { class: 'ac-eticheta', text: 'О СЕБЕ' }),
        bioEl,
      ]),
      el('div', { class: 'set-actions' }, [
        el('button', {
          class: 'btn primary', text: 'Сохранить',
          onclick: async () => {
            try {
              await session.saveProfile(bioEl.value);
              stare.textContent = 'Сохранено';
              toast('Профиль обновлён', 'success');
            } catch (err) { stare.textContent = err.message; }
          },
        }),
        stare,
      ]),
    ]);
  }

  /** Un câmp care se vede, dar nu se schimbă de aici. */
  #campCitire(eticheta, valoare, nota) {
    return el('div', { class: 'ac-camp' }, [
      el('span', { class: 'ac-eticheta', text: eticheta.toUpperCase() }),
      el('div', { class: 'ac-fix' }, [
        el('span', { text: valoare }),
        el('span', { class: 'ac-nota', text: nota }),
      ]),
    ]);
  }

  #cardAvatar(u) {
    const previzualizare = el('span', { class: 'ac-av-mare' });
    pictAvatar(previzualizare, u, 72);

    const grila = el('div', { class: 'av-grid' });
    grila.style.display = 'none';

    const alege = async (valoare) => {
      try {
        const actualizat = await session.saveAvatar(valoare);
        pictAvatar(previzualizare, actualizat, 72);
        for (const b of grila.children) b.classList.toggle('on', b.dataset.v === valoare);
        toast('Аватар обновлён', 'success');
      } catch (err) { toast(err.message, 'error'); }
    };

    for (let i = 0; i < NUMAR_PRESETURI; i++) {
      const b = el('button', { class: `av-opt${u.avatar === `preset:${i}` ? ' on' : ''}`,
        dataset: { v: `preset:${i}` }, onclick: () => alege(`preset:${i}`) });
      b.append(avatarPreset(i, 42));
      grila.append(b);
    }

    return el('section', { class: 'ac-card' }, [
      el('div', { class: 'set-card-head' }, [icon('camera', 15), el('h3', { text: 'Аватар' })]),
      el('div', { class: 'ac-av-rand' }, [
        previzualizare,
        el('p', { class: 'set-hint', text: 'Загрузите свою фотографию — её можно подвинуть '
          + 'и приблизить в кадре — или возьмите один из готовых рисунков. '
          + 'Картинка сжимается прямо в браузере, на сервер уходят килобайты.' }),
      ]),
      el('div', { class: 'set-actions' }, [
        // Incarcarea sta prima: e ce vrea omul in noua cazuri din zece, iar desenele
        // sunt varianta pentru cine nu vrea sa-si puna fata.
        el('button', { class: 'btn primary', onclick: () => alegeSiEditeaza({
          forma: 'cerc', latimeIesire: 512, raport: 1, tinta: 110 * 1024,
          titlu: 'Аватар — подвиньте и приблизьте',
        }, alege) }, [icon('upload', 12), el('span', { text: 'Загрузить фото' })]),
        el('button', { class: 'btn', onclick: () => {
          grila.style.display = grila.style.display === 'none' ? '' : 'none';
        } }, [icon('palette', 12), el('span', { text: 'Готовые рисунки' })]),
        u.avatar ? el('button', { class: 'btn', text: 'Убрать', onclick: () => alege('') }) : null,
      ]),
      grila,
    ]);
  }

  /** Banda de sus a profilului. Acelasi drum ca la avatar, alt cadru. */
  #cardCoperta(u) {
    const previzualizare = el('div', { class: 'ac-coperta' });
    pictCover(previzualizare, u, u.status?.color);

    const grila = el('div', { class: 'cv-grid' });
    grila.style.display = 'none';

    const alege = async (valoare) => {
      try {
        const actualizat = await session.saveCover(valoare);
        pictCover(previzualizare, actualizat, actualizat.status?.color);
        for (const b of grila.children) b.classList.toggle('on', b.dataset.v === valoare);
        toast('Обложка обновлена', 'success');
      } catch (err) { toast(err.message, 'error'); }
    };

    for (let i = 0; i < NUMAR_COPERTI; i++) {
      grila.append(el('button', {
        class: `cv-opt${u.cover === `cover:${i}` ? ' on' : ''}`,
        dataset: { v: `cover:${i}` }, style: `background:${coperta(i)}`,
        onclick: () => alege(`cover:${i}`),
      }));
    }

    return el('section', { class: 'ac-card' }, [
      el('div', { class: 'set-card-head' }, [icon('image', 15), el('h3', { text: 'Обложка профиля' })]),
      previzualizare,
      el('p', { class: 'set-hint', text: 'Широкая полоса в шапке профиля. '
        + 'Своя картинка кадрируется так же, как аватар.' }),
      el('div', { class: 'set-actions' }, [
        el('button', { class: 'btn primary', onclick: () => alegeSiEditeaza({
          forma: 'banda', latimeIesire: 1600, raport: 4.5, tinta: 420 * 1024,
          titlu: 'Обложка — подвиньте и приблизьте',
        }, alege) }, [icon('upload', 12), el('span', { text: 'Загрузить фото' })]),
        el('button', { class: 'btn', onclick: () => {
          grila.style.display = grila.style.display === 'none' ? '' : 'none';
        } }, [icon('palette', 12), el('span', { text: 'Готовые обложки' })]),
        u.cover ? el('button', { class: 'btn', text: 'Убрать', onclick: () => alege('') }) : null,
      ]),
      grila,
    ]);
  }

  #cardBursa() {
    const bursaEl = el('select', { class: 'set-select' }, EXCHANGE_LIST.map((x) => el('option', {
      value: x.key, text: x.label, selected: x.key === settings.get('sx_exchange', 'binance'),
    })));
    const piataEl = el('select', { class: 'set-select' },
      [['futures', 'Фьючерсы'], ['spot', 'Спот']].map(([v, t]) => el('option', {
        value: v, text: t, selected: v === settings.get('sx_market', 'futures'),
      })));
    const stare = el('span', { class: 'set-hint' });

    return el('section', { class: 'ac-card' }, [
      el('div', { class: 'set-card-head' }, [icon('chartLine', 15), el('h3', { text: 'Моя биржа' })]),
      el('p', { class: 'set-hint', text: 'Где вы торгуете. Скринер, сетка, радар и '
        + 'плотности будут открываться на ней — выбирать каждый раз не нужно.' }),
      el('div', { class: 'set-row' }, [bursaEl, piataEl]),
      el('div', { class: 'set-actions' }, [
        el('button', {
          class: 'btn primary', text: 'Применить',
          onclick: async () => {
            stare.textContent = 'Применяем…';
            try {
              await this.app.setExchange(bursaEl.value);
              await this.app.setMarket(piataEl.value);
              toast(`${bursaEl.selectedOptions[0].text} · ${piataEl.selectedOptions[0].text}`, 'success');
            } catch (err) { stare.textContent = err.message; }
          },
        }),
        stare,
      ]),
    ]);
  }

  #cardParola() {
    const { field: vechiField, input: vechiEl } = passwordField('Текущий пароль');
    const { field: nouField, input: nouEl } = passwordField('Новый пароль', 'new-password');
    const { field: nou2Field, input: nou2El } = passwordField('Повторите новый', 'new-password');
    const errEl = el('div', { class: 'auth-error' });

    return el('section', { class: 'ac-card' }, [
      el('div', { class: 'set-card-head' }, [icon('lock', 15), el('h3', { text: 'Пароль' })]),
      el('p', { class: 'set-hint', text: 'Минимум 6 символов. После смены '
        + 'все открытые сессии закроются — включая эту.' }),
      el('div', { class: 'ac-rand' }, [vechiField, nouField, nou2Field]),
      errEl,
      el('div', { class: 'set-actions' }, [
        el('button', {
          class: 'btn', text: 'Сменить пароль',
          onclick: async () => {
            errEl.textContent = '';
            try {
              // Repetarea se verifică aici: o parolă nouă greşit tastată de două ori te
              // încuie afară, iar asta se descoperă abia la următoarea intrare.
              if (nouEl.value !== nou2El.value) throw new Error('Пароли не совпадают');
              await session.changePassword(vechiEl.value, nouEl.value);
              toast('Пароль изменён — войдите заново', 'success');
            } catch (err) { errEl.textContent = err.message; }
          },
        }),
      ]),
    ]);
  }

  unmount() {
    this.offSession?.();
    this.root?.remove();
  }
}
